import { getParams } from "@/helpers/url.js";
import staticFeatureToggles from "@/assets/json/feature-toggles.json";
import isBoolean from "lodash-es/isBoolean";
import mapValues from "lodash-es/mapValues";

export const getFeatureToggles = (routerQueryParams = {}) => {
  const localStorageFeatureToggles = JSON.parse(
    localStorage.getItem("featureToggles") || "{}"
  );

  const queryParams = {
    ...getParams(window.location),
    ...routerQueryParams,
  };

  const stringToRemove = "ft-";
  const filteredQueryParams = {};

  Object.entries(queryParams).forEach(([key, value]) => {
    if (key.includes(stringToRemove)) {
      const newKey = key.replace(stringToRemove, "");
      filteredQueryParams[newKey] = value;
    }
  });

  // In order of priority, low to high
  // Higher priority overwrites lower priority
  const mergedFeatureToggles = {
    ...localStorageFeatureToggles,
    ...filteredQueryParams,
    ...staticFeatureToggles,
  };

  // Parse numeric and boolean values
  const parsedFeatureToggles = mapValues(mergedFeatureToggles, (value) => {
    if (isBoolean(value)) {
      return value;
    }

    if (/^(true|false)$/.test(value)) {
      return value === "true";
    }

    if (/^\d+$/.test(value)) {
      return parseInt(value, 10);
    }

    return value;
  });

  localStorage.setItem("featureToggles", JSON.stringify(parsedFeatureToggles));

  return parsedFeatureToggles;
};

export const setFeatureToggles = (featureToggles) => {
  const currentFeatureToggles = getFeatureToggles();
  const newFeatureToggles = {
    ...currentFeatureToggles,
    ...featureToggles,
  };
  localStorage.setItem("featureToggles", JSON.stringify(newFeatureToggles));
};
